import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class Member{
  id:number;
  name:string;
  role:string;
  phone:string;
  email:string;
  image:string;
}
@Injectable({
  providedIn: 'root'
})
export class TeamService {
  private Team:Member[];
  get team():Member[]{
    if(this.Team === undefined || this.Team === null){
      this.Team = [];
      this.loadTeam();
    }
    return this.Team;
  }
  constructor(private http:HttpClient) { }
  loadTeam() {
    this.http.get<Member[]>('assets/data/team.json').subscribe(response=>{
      for(const member of response){
        this.Team.push(member);
      }
    });
  }
}
